export const rapid60 = newValues => {
  //Conectores
  if (newValues.EV_NUM_CONECTORES === "60_ONE") {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = ""
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = ""
  }

  if (newValues.EV_NUM_CONECTORES === "60_ONE_PLUS") {
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = ""
  }

  if (newValues.EV_NUM_CONECTORES === "60_DUO") {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = ""
  }

  if (
    newValues.EV_NUM_CONECTORES === "60_ONE_PLUS" &&
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT === ""
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = "AC_22"
  }

  if (
    newValues.EV_NUM_CONECTORES === "60_DUO" &&
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE === ""
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = newValues.EV_TIPO_CONECTOR_RIGHT_SIDE
  }

  if (
    newValues.EV_NUM_CONECTORES === "60_TRIO" &&
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE === ""
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_SIDE = newValues.EV_TIPO_CONECTOR_RIGHT_SIDE
  }

  if (
    newValues.EV_NUM_CONECTORES === "60_TRIO" &&
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT === ""
  ) {
    newValues.EV_TIPO_CONECTOR_LEFT_FRONT = "AC_22"
  }

  return newValues
}
